import { service } from '@/common/request/request.js'

// 获取游戏列表
export function getGame(data = {}, type = 0) {
  // 0 平台全部游戏 1 平台最新游戏 2 平台热门游戏
  const urls = ['/game/guest/allGame', '/game/guest/newGame', '/game/guest/hotGame']
  return service({
    url: urls[type],
    method: 'post',
    data
  })
}

// 获取所有平台
export function getAllPlatform(data = {}) {
  return service({
    url: '/loged/getAllPlatform',
    method: 'post',
    data
  })
}

// 获取最热游戏列表
export function getHotGameList(data = {}) {
  return service({
    url: '/guest/gameList',
    method: 'post',
    data
  })
}

// 获取所有的电子游戏平台名称列表
export function getGamePlatform(data = {}) {
  return service({
    url: '/guest/getGamePlatform',
    method: 'post',
    data
  })
}

// 根据游戏平台代码，获取游戏列表
export function getSlotGameByPlatform(data = {}) {
  return service({
    url: '/guest/getSlotGameByPlatform',
    method: 'post',
    data
  })
}

// 获取所有游戏列表和平台, 其中gameType:1 - 电子，2-真人，3-体育，4-彩票，5-捕鱼，6-棋牌
export function getAllGameInfo(data = {}) {
  return service({
    url: '/guest/allGameInfo',
    method: 'post',
    data
  })
}

// 获取启用的自定义赛事 365体育信息
export function getCustomizeMatch(data = {}) {
  return service({
    url: '/guest/getCustomizeMatch',
    method: 'post',
    data
  })
}

// 根据体育游戏平台获取赛事信息
export function getMatchByCode(data = {}) {
  return service({
    url: '/guest/getMatchByPlatformCode',
    method: 'post',
    data
  })
}

// 获取热门游戏以及平台
export function getHotGamePlatform(data = {}, type = 0) {
  // 0 获取热门游戏平台及游戏  1 获取热门游戏平台
  const urls = ['/game/guest/newHeatGamePlatform', '/game/guest/heatGamePlatform']
  return service({
    url: urls[type],
    method: 'post',
    data
  })
}

// 获取游戏类型列表
export function getPlatformByPlatCode(data = {}) {
  return service({
    url: '/game/guest/gamePlatform',
    method: 'post',
    data
  })
}

// 获取游戏的近n日流水数据
export function getGameAccount(data = {}) {
  return service({
    url: '/logged/topFlowData',
    method: 'post',
    data
  })
}

// 获取搜索电子游戏的结果
export function getSoltGameList(data = {}) {
  return service({
    url: '/guest/searchResult',
    method: 'post',
    data
  })
}

// 获取游戏列表
export function getAllGameList(data = {}) {
  return service({
    url: '/game/guest/queryAllGameList',
    method: 'post',
    data
  })
}

// 获取电子游戏banner
export function getSlotBanner(data = {}) {
  return service({
    url: '/guest/slotBanner',
    method: 'post',
    data
  })
}

// 获取电子游戏的相关优惠
export function getSlotDiscounts(data = {}) {
  return service({
    url: '/guest/slotOffer',
    method: 'post',
    data
  })
}

// 获取电子游戏的压码游戏排行列表
export function getSlotRank(data = {}) {
  return service({
    url: '/guest/slotRank',
    method: 'post',
    data
  })
}

// 获取电子游戏全部游戏列表
export function getAllSlotGame(data = {}) {
  return service({
    url: '/guest/totalSlot',
    method: 'post',
    data
  })
}

// 获取电子游戏可能喜欢的6个游戏
export function getLikeGame(data = {}) {
  return service({
    url: '/logged/maybeLike',
    method: 'post',
    data
  })
}

// 我的电子游戏列表
export function getMySlotList(data = {}) {
  return service({
    url: '/logged/mySlot',
    method: 'post',
    data
  })
}

// 添加游戏至我的收藏
export function collectGame(data = {}) {
  return service({
    url: '/logged/addCollection',
    method: 'post',
    data
  })
}

// 取消游戏收藏
export function removeGameFromCollect(data = {}) {
  return service({
    url: '/logged/cancelCollection',
    method: 'post',
    data
  })
}

// 老虎机筛选全选参数不用传,例如5-10线,传min=5,max=10,10线以下传min=10,50线以上传max=50,
// type,1=奖池游戏,2=经典游戏,3=消消乐,4=电动角子，hotOrNew，0=最新游戏，5=热门游戏,platformCode,平台编号
export function filterSlotGame(data = {}) {
  return service({
    url: '/guest/selectGameSlotType',
    method: 'post',
    data
  })
}

// 获取游戏投注记录
export function getBetList(data = {}, type = 0) {
  const urls = ['/game/logged/newGameHistory', '/game/logged/gameHistory']
  return service({
    url: urls[type],
    method: 'post',
    data
  })
}

// 获取游戏平台收藏列表
export function getCollectList(data = {}) {
  return service({
    url: '/game/logged/selectUserCollectionList',
    method: 'post',
    data
  })
}

// 获取游戏平台收藏列表的id
export function getCollectIds(data = {}) {
  return service({
    url: '/game/logged/selectUserCollectionListIds',
    method: 'post',
    data
  })
}

// 添加游戏平台收藏
export function addCollect(data = {}) {
  return service({
    url: '/game/logged/addCollection',
    method: 'post',
    data
  })
}

// 取消游戏平台收藏
export function cancelCollect(data = {}) {
  return service({
    url: '/game/logged/cancelCollection',
    method: 'post',
    data
  })
}


// 获取游戏类型列表分组
export function gamePlatGroup(data = {}) {
  return service({
    url: '/game/guest/gamePlatformGroup',
    method: 'post',
    data
  })
}

// 根据真人平台或类型获取真人信息
export function liveGameList(data = {}) {
  return service({
    url: '/guest/liveGameList',
    method: 'post',
    data
  })
}

// 获取游戏平台的图片:游戏类型: -1 - 所有，1 - 电子，2-真人，3-体育，4-彩票，5-捕鱼，6-棋牌
export function gamePlatformInfo(data = {}) {
  return service({
    url: '/guest/platformPicInfo',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/common/api/game.js